import React, { useState, useEffect } from "react";
import { Container, MailList } from "./style";
import PersonIcon from "@mui/icons-material/Person";
import {
  BoldLg,
  BoldMed,
  BoldSm,
  HorizontalAlign,
  HorizontalLeftAlign,
  RegLg,
  RegMed,
  RegSm,
  RegSmPri,
  SpaceBetween,
  TruncatedText,
  VerticalAlign,
} from "../../../../Components/CustomStyles";
import AddIcon from "@mui/icons-material/Add";
import SyncIcon from "@mui/icons-material/Sync";
import SmartImage from "../../../../Components/SmartImage";
import dayjs from "dayjs";
import { useDispatch } from "react-redux";
import { readMailRequest } from "../../../../Redux/actions/home";
import ClipLoader from "react-spinners/ClipLoader";
import Colors from "../../../../Constant/Colors";

const MailSideBar = ({
  mails,
  handleCurrentMail,
  openNewMail,
  isLoading,
  getMail,
  mailShowingList,
  setCurrentMail,
  currentTab,
}) => {
  const dispatch = useDispatch();
  const [mailList, setMailList] = useState(mails);

  const openMail = (mail) => {
    handleCurrentMail(mail);
    if (mail.unread && currentTab !== 4) dispatch(readMailRequest(mail?.id));
  };

  const handleReadMails = (status) => {
    if (status === 1) {
      getMail("");
    } else if (status === 2) {
      getMail("unread", false);
    } else if (status === 3) {
      getMail("unread", true);
    } else {
      getMail("sent", true);
    }
    mailShowingList.forEach((fe) => {
      fe.isSelected = status === fe?.id;
    });
    setCurrentMail(null);
  };

  const refreshMailList = () => {
    let status = mailShowingList.find((f) => f.isSelected)?.id;
    if (status === 1) {
      getMail("");
    } else if (status === 2) {
      getMail("unread", false);
    } else if (status === 3) {
      getMail("unread", true);
    } else {
      getMail("sent", true);
    }
  };
  useEffect(() => {
    setMailList(mails);
  }, [mails]);

  const styles = {
    list: (isSelected) => ({
      padding: 2,
      paddingLeft: 4,
      paddingRight: 4,
      margin: 2,
      cursor: "pointer",
      borderRadius: 5,
      backgroundColor: isSelected
        ? Colors.lightGrayColor2
        : Colors.whiteThemeColor,
    }),
    mailView: (isSelected) => ({
      padding: 5,
      cursor: "pointer",
      height: 38,
      marginBottom: 10,
      overflow: "hidden",
      backgroundColor: isSelected
        ? Colors.lightGrayColor
        : Colors.whiteThemeColor,
    }),
  };

  return (
    <Container toggleSideBar={true}>
      <SpaceBetween>
        <HorizontalLeftAlign>
          {mailShowingList.map((each) => (
            <BoldMed
              onClick={() => handleReadMails(each?.id)}
              style={styles.list(each.isSelected)}
            >
              {each.title}
            </BoldMed>
          ))}
        </HorizontalLeftAlign>
        <HorizontalAlign>
          <span onClick={openNewMail}>
            <AddIcon style={{ padding: 5, cursor: "pointer" }} />
          </span>
          <SyncIcon
            style={{ padding: 5, cursor: "pointer" }}
            onClick={refreshMailList}
          />
        </HorizontalAlign>
      </SpaceBetween>
      <MailList>
        {isLoading ? (
          <VerticalAlign style={{ height: 100 }}>
            <ClipLoader color={Colors.primary} size={20} />
          </VerticalAlign>
        ) : mailList.length ? (
          mailList.map((each) => (
            <div
              style={styles.mailView(each?.isSelected)}
              onClick={() => openMail(each)}
              key={each?.id}
            >
              <SpaceBetween>
                <HorizontalAlign style={{ alignItems: "flex-start" }}>
                  {each?.sender?.profile_pic ? (
                    <SmartImage
                      src={each?.sender?.profile_pic}
                      style={{ height: 25, width: 25, marginRight: 10 }}
                    />
                  ) : (
                    <PersonIcon
                      style={{
                        color: Colors.primary,
                        fontSize: 20,
                        marginRight: 5,
                        marginTop: 2,
                      }}
                    />
                  )}
                  <TruncatedText>
                    {!each?.unread || currentTab === 4 ? (
                      <RegLg>{each?.subject}</RegLg>
                    ) : (
                      <BoldLg>{each?.subject}</BoldLg>
                    )}
                  </TruncatedText>
                </HorizontalAlign>
                {!each?.unread || currentTab === 4 ? (
                  <RegSm>{dayjs(each?.sent_at).format("MMM DD")}</RegSm>
                ) : (
                  <BoldSm>{dayjs(each?.sent_at).format("MMM DD")}</BoldSm>
                )}
              </SpaceBetween>
              <div style={{ paddingLeft: 28, marginTop: -17 }}>
                <TruncatedText>
                  {!each?.unread || currentTab === 4 ? (
                    <RegMed dangerouslySetInnerHTML={{ __html: each?.body }} />
                  ) : (
                    <BoldMed dangerouslySetInnerHTML={{ __html: each?.body }} />
                  )}
                </TruncatedText>
              </div>
            </div>
          ))
        ) : (
          <HorizontalAlign style={{ marginTop: 30 }}>
            <RegSmPri>No mail to show</RegSmPri>
          </HorizontalAlign>
        )}
      </MailList>
    </Container>
  );
};

export default MailSideBar;
